import { render } from "./HowTo.vue?vue&type=template&id=6a904189"
import script from "./HowTo.vue?vue&type=script&lang=js"
export * from "./HowTo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__